var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteSemicolon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 67,
    viewBox: "0 0 90 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.008 66.612C13.9893 66.612 9.10933 64.4973 5.368 60.268C1.78933 55.876 0 50.1827 0 43.188C0 34.0787 2.684 25.62 8.052 17.812C13.42 9.84133 20.0893 3.904 28.06 0L29.524 2.92799C26.108 5.53066 23.0987 8.86533 20.496 12.932C17.8933 16.9987 16.0227 22.0413 14.884 28.06L20.008 29.28C25.7013 30.5813 30.0933 33.0213 33.184 36.6C36.4373 40.016 38.064 44.164 38.064 49.044C38.064 54.2493 36.2747 58.4787 32.696 61.732C29.28 64.9853 25.0507 66.612 20.008 66.612ZM71.492 66.612C65.4733 66.612 60.5933 64.4973 56.852 60.268C53.2733 55.876 51.484 50.1827 51.484 43.188C51.484 34.0787 54.168 25.62 59.536 17.812C64.904 9.84133 71.5733 3.904 79.544 0L81.008 2.92799C77.592 5.53066 74.5827 8.86533 71.98 12.932C69.3773 16.9987 67.5067 22.0413 66.368 28.06L71.492 29.28C77.1853 30.5813 81.5773 33.0213 84.668 36.6C87.9213 40.016 89.548 44.164 89.548 49.044C89.548 54.2493 87.7587 58.4787 84.18 61.732C80.764 64.9853 76.5347 66.612 71.492 66.612Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSemicolon);
export default __webpack_public_path__ + "static/media/WhiteSemicolon.c6f158cf2d8867d06b865cc499569414.svg";
export { ForwardRef as ReactComponent };